export class OverlayTitleStyle {
  size = 'uk-heading-small';
  color = 'uk-color-black';
  decoration = '';
  decorationColor = '';
  font = 'tb-font-primary';
  transition = '';
  marginTop = 'uk-margin-top';
  cursor = '';
  alignment = '';

  static normalize(styles: Partial<OverlayTitleStyle>): OverlayTitleStyle {
    const pureStyles = new OverlayTitleStyle();

    pureStyles.size = styles.size ?? pureStyles.size;
    pureStyles.color = styles.color ?? pureStyles.color;
    pureStyles.decoration = styles.decoration ?? pureStyles.decoration;
    pureStyles.decorationColor = styles.decorationColor ?? pureStyles.decorationColor;
    pureStyles.font = styles.font ?? pureStyles.font;
    pureStyles.transition = styles.transition ?? pureStyles.transition;
    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;
    pureStyles.cursor = styles.cursor ?? pureStyles.cursor;
    pureStyles.alignment = styles.alignment ?? pureStyles.alignment;

    return pureStyles;
  }
}
